<!-- header -->
<header
class="sticky-header"
[class.sticky]="isSticky"
[class.header-visible]="isHeaderVisible"
[class.header-hidden]="!isHeaderVisible"
>
  <nav class="navbar navbar-expand-lg bg-body-tertiary">
    <div class="container navbarCustom">
      <a class="navbar-brand" [routerLink]="['/']" (click)="closeAllDropdowns()">
        <img src="images/logo.svg" alt="" class="img-fluid" />
      </a>

      <!-- Mobile actions container (search icon + hamburger) -->
      <div class="mobile-actions d-flex d-lg-none align-items-center">
        <!-- Mobile Search Icon -->
        <button
          class="mobile-search-toggle"
          type="button"
          (click)="toggleMobileSearch($event)"
          aria-label="Toggle search"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.58317 17.5001C13.9554 17.5001 17.4998 13.9557 17.4998 9.58341C17.4998 5.21116 13.9554 1.66675 9.58317 1.66675C5.21092 1.66675 1.6665 5.21116 1.6665 9.58341C1.6665 13.9557 5.21092 17.5001 9.58317 17.5001Z"
              stroke="#4E4F50"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M18.3332 18.3334L16.6665 16.6667"
              stroke="#4E4F50"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>

        <!-- Mobile Menu Toggle -->
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          [attr.aria-expanded]="isMobileMenuOpenState()"
          aria-label="Toggle navigation"
          (click)="onMobileMenuToggle()"
        >
          <!-- Hamburger icon (3 lines) when menu is closed -->
          <span class="navbar-toggler-icon" *ngIf="!isMobileMenuOpenState()">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 12H21"
                stroke="#4E4F50"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3 6H21"
                stroke="#4E4F50"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3 18H21"
                stroke="#4E4F50"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>

          <!-- Cross icon (X) when menu is open -->
          <span class="navbar-toggler-icon" *ngIf="isMobileMenuOpenState()">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18"
                stroke="#4E4F50"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="#4E4F50"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        </button>
      </div>

      <div class="collapse navbar-collapse" id="navbarSupportedContent" [ngClass]="{'show-all-mobile-menu': showMobileSearch && isMobileMenuOpenState()}">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <ng-container *ngFor="let menu of filteredMenuItems; let i = index">
            <li
              class="nav-item"
              [ngClass]="{ dropdown: menu.submenu && menu.title !== 'Interviews' && !menu.isMoreDropdown }"
              *ngIf="!menu.isMoreDropdown"
            >
              <!-- Normal menu (no submenu) -->
              <a
                class="nav-link"
                *ngIf="!menu.submenu && menu.title !== 'Interviews'"
                [routerLink]="menu.routerLink"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="closeAllDropdowns()"
              >
                {{ menu.title.replace("-", " ") }}
              </a>

              <!-- Interviews dropdown handled manually -->
              <ng-container *ngIf="menu.title === 'Interviews'">
                <li class="nav-item position-relative"
                    (mouseenter)="openInterviewMenu()"
                    (mouseleave)="closeInterviewMenu()"
                    (click)="toggleInterviewMenuMobile($event)">
                  <span class="nav-link">
                    {{ menu.title }}
                    <span>
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.96004 4.4751L6.70004 7.7351C6.31504 8.1201 5.68504 8.1201 5.30004 7.7351L2.04004 4.4751"
                          stroke="#4E4F50"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </span>
                  <!-- Interviews submenu -->
                  <div
                    class="interview-dropdown-container"
                    *ngIf="showInterviewMenu"
                  >
                    <!-- Left: Categories -->
                    <ul class="interview-dropdown-left">
                      <li
                        *ngFor="let category of menu.submenu"
                        [class.active]="activeInterviewCategory === category"
                        class="dropdown-submenu"
                      >
                        <a
                          class="dropdown-item"
                          href="#"
                          (click)="toggleInterviewSubmenu(category, $event)"
                        >
                          {{ category.category }}
                          <span
                            *ngIf="
                              category.children && category.children.length > 0
                            "
                            class="dropdown-arrow"
                            ><svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_158_830)">
                                <path
                                  d="M6 3L11 8L6 13"
                                  stroke="#C22727"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_158_830">
                                  <rect width="16" height="16" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </span>
                        </a>
                      </li>
                    </ul>

                    <!-- Middle: Selected category's children -->
                    <ul class="interview-dropdown-middle">
                      <li *ngFor="let child of activeInterviewCategory?.children">
                        <a
                          class="dropdown-item"
                          href="#"
                          (click)="onCategorySelect(child, $event)"
                        >
                          {{ child.title }}
                        </a>
                      </li>
                      <!-- Show message if no children available -->
                      <li *ngIf="!activeInterviewCategory?.children || activeInterviewCategory?.children.length === 0">
                        <span class="dropdown-item text-muted">No subcategories available</span>
                      </li>
                    </ul>

                    <!-- Right: Info section -->
                    <div class="interview-dropdown-right" (click)="$event.stopPropagation()">
                      <div class="share-section" (click)="$event.stopPropagation()">
                        <div class="share-title">Share on:</div>
                        <div class="share-icons" (click)="$event.stopPropagation()">
                          <!-- Dynamic Share Buttons from API -->
                          <div [innerHTML]="shareButtonsHtml" class="addtoany-share-buttons" *ngIf="shareButtonsHtml && !isLoadingShareButtons" (click)="$event.stopPropagation()"></div>
                          <a (click)="shareToInstagram(); $event.preventDefault(); $event.stopPropagation()" style="cursor: pointer; color: #000;"
                                                        title="Share on Instagram: SuperLawyer">
                                                             <img src="images/insta-new.svg.svg" alt="Share on Instagram" class="img-fluid" />
                          </a>
                          <!-- Loading state for share buttons -->
                          <div class="share-buttons-loading" *ngIf="isLoadingShareButtons">
                            <div class="spinner-border spinner-border-sm text-muted" role="status">
                              <span class="visually-hidden">Loading...</span>
                            </div>
                          </div>

                          <!-- Fallback static buttons if API fails -->
                          <div class="fallback-share-buttons" *ngIf="!shareButtonsHtml && !isLoadingShareButtons" (click)="$event.stopPropagation()">
                            <a href="#" aria-label="Share on X" (click)="$event.stopPropagation()"
                              ><img
                                src="images/twitter.svg"
                                alt=""
                                class="img-fluid"
                            /></a>
                            <a
                              href="mailto:?subject=SuperLawyer%20Interview"
                              aria-label="Share by Email"
                              (click)="$event.stopPropagation()"
                              ><img src="images/mail.svg" alt="" class="img-fluid"
                            /></a>
                            <a href="#" aria-label="Share on Pinterest" (click)="$event.stopPropagation()"
                              ><img
                                src="images/pinterest.svg"
                                alt=""
                                class="img-fluid"
                            /></a>
                            <a href="#" aria-label="Share on LinkedIn" (click)="$event.stopPropagation()"
                              ><img
                                src="images/linkdin.svg"
                                alt=""
                                class="img-fluid"
                            /></a>
                            <a href="#" aria-label="Share on WhatsApp" (click)="$event.stopPropagation()"
                              ><img
                                src="images/whatsapp.svg"
                                alt=""
                                class="img-fluid"
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="share-description" (click)="$event.stopPropagation()">
                        We are trying to democratise the way we take interviews
                        and the people we approach as such. If you would like to
                        suggest or recommend an interview for someone please use
                        this Google form:
                      </div>
                      <a
                        class="interview-request-btn"
                        [href]="googleFormUrl"
                        target="_blank"
                        (click)="$event.stopPropagation()"
                        >SuperLawyer Interview Request Form</a
                      >
                      <div class="share-note" (click)="$event.stopPropagation()">
                        <em>It would not take you more than a minute or so.</em>
                      </div>
                    </div>
                  </div>
                </li>
              </ng-container>

              <!-- Submenu (recursive if needed) -->
              <ng-container *ngIf="menu.submenu && menu.title !== 'Interviews'">
                <ul class="dropdown-menu">
                  <li *ngFor="let submenu of menu.submenu">
                    <a
                      class="dropdown-item"
                      [routerLink]="submenu.routerLink"
                      (click)="closeAllDropdowns()"
                    >
                      {{ submenu.title }}
                    </a>
                  </li>
                </ul>
              </ng-container>
            </li>

            <!-- More dropdown: Render after Youtube Channel -->
            <ng-container *ngIf="menu.isMoreDropdown">
              <li class="nav-item position-relative more-dropdown"
                  (mouseenter)="openMoreMenu()"
                  (mouseleave)="closeMoreMenu()"
                  (click)="toggleMoreMenuMobile($event)">
                <span class="nav-link">
                  More
                  <span>
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.96004 4.4751L6.70004 7.7351C6.31504 8.1201 5.68504 8.1201 5.30004 7.7351L2.04004 4.4751"
                        stroke="#4E4F50"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </span>
                <!-- More custom dropdown -->
                <div class="interview-dropdown-container" *ngIf="showMoreMenu">
                  <ul class="interview-dropdown-left">
                    <li *ngFor="let moreMenu of moreMenuItems">
                      <a
                        class="dropdown-item"
                        [routerLink]="moreMenu.routerLink"
                        (click)="closeAllDropdowns()"
                      >
                        {{ moreMenu.title }}
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ng-container>
          </ng-container>
        </ul>

        <!-- Search form -->
        <form
          class="form-search d-flex"
          role="search"
          (ngSubmit)="onSearch()"
          (click)="closeAllDropdowns()"
        >
          <input
            class="form-control me-2"
            type="text"
            placeholder="Search"
            aria-label="Search"
            [(ngModel)]="searchQuery"
            name="search"
            (keydown.enter)="onSearch()"
            (input)="onSearchChange($event)"
          />

          <!-- Search button (magnifying glass) -->
          <button class="search-btn" type="submit" [disabled]="isSearching">
            <div *ngIf="isSearching" class="search-spinner">
              <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Searching...</span>
              </div>
            </div>
            <svg
              *ngIf="!isSearching"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.58317 17.5001C13.9554 17.5001 17.4998 13.9557 17.4998 9.58341C17.4998 5.21116 13.9554 1.66675 9.58317 1.66675C5.21092 1.66675 1.6665 5.21116 1.6665 9.58341C1.6665 13.9557 5.21092 17.5001 9.58317 17.5001Z"
                stroke="#8E8E93"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M18.3332 18.3334L16.6665 16.6667"
                stroke="#8E8E93"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>

          <!-- Clear/Cross button -->
          <button
            *ngIf="searchQuery && searchQuery.length > 0"
            class="search-clear-btn"
            type="button"
            (click)="clearSearch()"
            aria-label="Clear search"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 4L4 12M4 4L12 12"
                stroke="#8E8E93"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </form>

        <!-- Auth buttons -->
        <div class="auth-buttons">
          <!-- <a href="#" class="sign-up">Sign Up</a> -->
          <div class="contact-popup-wrapper"
               (mouseenter)="openContactPopup()"
               (mouseleave)="closeContactPopup()">
            <button class="contact-us" tabindex="0">
              Contact Us
            </button>

            <!-- Contact Popup -->
            <div class="contact-popup" *ngIf="showContactPopup">
              <div class="popup-content">
                <a
                  [routerLink]="['/recommend-an-interview']"
                  class="popup-option"
                  (click)="closeContactPopup(); closeAllDropdowns()"
                >
                  Suggest An Interview
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>

  <!-- Mobile Search Bar (appears below header when toggled) -->
  <div class="mobile-search-container d-lg-none" *ngIf="showMobileSearch" (click)="$event.stopPropagation()">
    <div class="container">
      <form class="mobile-search-form" (ngSubmit)="onMobileSearch()">
        <div class="mobile-search-input-group">
          <input
            id="mobileSearchInput"
            class="mobile-search-input"
            type="text"
            placeholder="Search interviews..."
            [(ngModel)]="mobileSearchQuery"
            name="mobileSearch"
            (keydown.enter)="onMobileSearch()"
            (input)="onMobileSearchChange($event)"
          />
          <button
            class="mobile-search-btn"
            type="submit"
            [disabled]="isSearching"
            aria-label="Search">
            <div *ngIf="isSearching" class="search-spinner">
              <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Searching...</span>
              </div>
            </div>
            <svg
              *ngIf="!isSearching"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.58317 17.5001C13.9554 17.5001 17.4998 13.9557 17.4998 9.58341C17.4998 5.21116 13.9554 1.66675 9.58317 1.66675C5.21092 1.66675 1.6665 5.21116 1.6665 9.58341C1.6665 13.9557 5.21092 17.5001 9.58317 17.5001Z"
                stroke="#8E8E93"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M18.3332 18.3334L16.6665 16.6667"
                stroke="#8E8E93"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <!-- Clear button (same behavior as desktop - refresh page and show all data) -->
          <button
            *ngIf="mobileSearchQuery && mobileSearchQuery.length > 0"
            class="mobile-search-clear-btn"
            type="button"
            (click)="clearMobileSearch()"
            aria-label="Clear search and refresh"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 4L4 12M4 4L12 12"
                stroke="#8E8E93"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <!-- Close button when no text -->
          <button
            *ngIf="!mobileSearchQuery || mobileSearchQuery.length === 0"
            class="mobile-search-close-btn"
            type="button"
            (click)="closeMobileSearch()"
            aria-label="Close search"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 4L4 12M4 4L12 12"
                stroke="#666"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Social section -->
  <div class="social-media-section" (click)="closeAllDropdowns()">
    <div class="container d-flex justify-content-between">
      <ul class="d-flex">
        <li>
          <a [href]="socialMediaLinks.linkedin" target="_blank">
            <i class="fa-brands fa-linkedin-in"></i>
          </a>
        </li>
        <li>
          <a href="#" target="_blank">
            <i class="fa-brands fa-square-facebook"></i>
          </a>
        </li>
        <li>
          <a [href]="socialMediaLinks.instagram" target="_blank">
            <i class="fa-brands fa-instagram"></i>
          </a>
        </li>
        <li>
          <a href="#" target="_blank">
            <i class="fa-brands fa-twitter"></i>
          </a>
        </li>
      </ul>
      <div class="mail">
        <span><i class="fa-solid fa-envelope"></i></span>
        <a href="mailto:superlawyer@lawsikho.in">superlawyer&#64;lawsikho.in</a>
      </div>
    </div>
  </div>
</header>
